<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="土地ID">
                <a-input v-model="queryParam.landId" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="操作类型">
                <a-select v-model="queryParam.operationType" allowClear>
                  <a-select-option :value="1">浇水</a-select-option>
                  <a-select-option :value="2">施肥</a-select-option>
                  <a-select-option :value="3">除草</a-select-option>
                  <a-select-option :value="4">捉虫</a-select-option>
                  <a-select-option :value="5">修剪</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="operationType" slot-scope="text, record">
          {{ getOperationName(record.operationType) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.editForm.handleEdit(record)"><a-icon type="edit" />修改次数</a>
        </span>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
      <edit-form ref="editForm" @ok="getList" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageOperationCount } from '@/api/cloudplant/operationCount'
import { tableMixin } from '@/store/table-mixin'
import EditForm from './modules/EditForm'

export default {
  name: 'LandOperationCount',
  mixins: [tableMixin],
  components: { EditForm },
  data() {
    return {
      list: [], loading: false, pageSizeOptions: ['10', '20', '50', '100'], total: 0,
      queryParam: { landId: undefined, operationType: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '土地ID', dataIndex: 'landId', align: 'center' },
        { title: '操作类型', dataIndex: 'operationType', scopedSlots: { customRender: 'operationType' }, align: 'center' },
        { title: '总次数', dataIndex: 'totalCount', align: 'center' },
        { title: '已用次数', dataIndex: 'usedCount', align: 'center' },
        { title: '剩余次数', customRender: (text, record) => record.totalCount - record.usedCount, align: 'center' },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() { this.loading = true; pageOperationCount(this.queryParam).then(response => { this.list = response.data.records; this.total = response.data.total; this.loading = false }) },
    getOperationName(type) { const names = { 1: '浇水', 2: '施肥', 3: '除草', 4: '捉虫', 5: '修剪' }; return names[type] || '' },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { landId: undefined, operationType: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() }
  }
}
</script>
